import http from "infra/http";
import { useMutation } from "react-query";
import { GrupoDescontoForm } from "../typings";

function useSaveGrupoDesconto() {
  return useMutation(
    `/v1/grupo-desconto/criar`,
    async (form: GrupoDescontoForm) => {
      
      const { data } = form.id ? await http.put<{id: string}>(`/v1/grupo-desconto/${form.id}`, form) : await http.post(`/v1/grupo-desconto`, form);

      return data;
    },
  );
}

export default useSaveGrupoDesconto;
